import { buildHead } from "@/lib/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

// Sellers browse live buyer demand and send quotes. Private, never indexed.
export const Route = createFileRoute("/_app/seller_/requirements")({
  head: () =>
    buildHead({
      title: "Buyer Requirements | LohaLink",
      description: "Live buyer demand for steel and scrap — send your quote.",
      canonical: "/seller/requirements",
      noindex: true,
    }),
  component: lazyRouteComponent(() => import("@/pages/SellerRequirements")),
});
